module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-6"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fm-head1"
  }, [_vm._v("Abbreviations")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("PCCRP")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Prerogative Court of Canterbury and Related Probate Jurisdictions")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2026f653","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/005_About_the_author.vue
// module id = 69
// module chunks = 0